import styles from './style.postcss';

import React, { Component } from 'react';
import is from 'is_js';
import PropTypes from 'prop-types';

import { buildUrl } from 'domain/Api';
import { exporter } from 'domain/Exporter';
import Languages from 'domain/Languages';

import { ConfirmDialog, ErrorDialog, log } from 'omni-common-ui';
import LanguageRadio from 'components/LanguageRadio';

const EXPORT_FILENAME = 'Unit Reports.pdf';
const EXPORT_MIME_TYPE = 'application/pdf';

class ExportDialog extends Component {
  constructor() {
    super();
    this.state = {
      isExportRequested: false,
    };

    this._onLanguageChanged = this._onLanguageChanged.bind(this);
  }

  componentWillMount() {
    this.setState({ choosedLanguageCode: this.props.languageCode });
  }

  _close() {
    const { buildRoute, pushRoute } = this.props;
    function redirect(param) {
      pushRoute(buildRoute(param));
    }
    redirect({ mode: '' });
  }

  _performExport() {
    const { progressReportId, studentId } = this.props;
    if (is.falsy(progressReportId)) {
      log.error('ExportAllHandler is not exporting - progressReportId is not set!');
      return;
    }

    const url =
      buildUrl(`/unit-reports/${progressReportId}/students/${studentId}/printable-student-reports-pdf?` +
      `languageCode=${this.state.choosedLanguageCode || Languages.defaultLanguageCode}`);

    exporter.get(url,
      EXPORT_FILENAME,
      false,
      EXPORT_MIME_TYPE)
      .then(() => { this._close(); })
      .catch(() => { this.setState({ isExportErrorOccurred: true }); });

    this.setState({ isExportRequested: true });
  }

  _onLanguageChanged(languageCode) {
    this.setState({ choosedLanguageCode: languageCode });
  }

  _isChecked(languageCode) {
    return languageCode === this.state.choosedLanguageCode;
  }

  _isDefaultLanguage() {
    if (! this.props.languageCode) return true;
    return Languages.defaultLanguageCode === this.props.languageCode;
  }

  _renderLanguageRadio() {
    return <LanguageRadio name="language-picker"
        languageCode={this.props.languageCode}
        onChecked={this._onLanguageChanged}
        choosedLanguageCode={this.state.choosedLanguageCode} />;
  }

  render() {
    if (this.state.isExportErrorOccurred) {
      return <ErrorDialog isOpen
          onConfirmClick={() => { this._close(); }} />;
    }


    if (! this._isDefaultLanguage()) {
      return <ConfirmDialog isOpen
          isLoading={this.state.isExportRequested}
          title="Choose Language:"
          primaryButtonContent="Export"
          secondaryButtonContent="Cancel"
          onPrimaryClick={() => this._performExport()}
          onSecondaryClick={() => this._close()}
          onRequestClose={() => this._close()}>
        <div className={styles.ExportAllHandler_feedback_content}>
          <div className={styles.ExportAllHandler_feedback_languageRadio}>
            {this._renderLanguageRadio()}
          </div>
        </div>
      </ConfirmDialog>;
    }
    // the export starts automatically!
    ! this.state.isExportRequested && this._performExport();
    return <ConfirmDialog isOpen
        isLoading
        isButtonless
        title="Exporting reports, please wait">
      <div className={styles.ExportAllHandler_feedback_exportingImmediately} />
    </ConfirmDialog>;
  }
}

ExportDialog.propTypes = {
  studentReportSummary: PropTypes.shape({
    filter: PropTypes.func.isRequired,
  }).isRequired,
  progressReportId: PropTypes.string.isRequired,
  languageCode: PropTypes.string.isRequired,
  buildRoute: PropTypes.func.isRequired,
  pushRoute: PropTypes.func.isRequired,
  studentId: PropTypes.func.isRequired,
};

export default ExportDialog;



// WEBPACK FOOTER //
// ./containers/Group/UnitReportHFv4/StudentReportView/ExportDialog/index.jsx